import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import "assets/css/nucleo-svg.css";
import "assets/css/nucleo-icons.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
//import "@fortawesome/fontawesome-free/js/all.min.js";
import "./main.scss?v1.0.0";
import store from "./redux";
import { Provider } from "react-redux";

//import "./custom-icons";

//import Amplify from "aws-amplify";
import awsExports from "./aws-exports";

//import LandingPage from "views/LandingPage.js";
const Homepage = lazy(() => import("views/Homepage"));
const SearchLanding = lazy(() => import("views/SearchLanding"));
const Blog = lazy(() => import("views/Blog/Blog"));
const BestingBoisePost = lazy(() => import("views/Blog/BestingBoisePost"));
const RelocatingWithSchoolAgeKidsPost = lazy(() =>
  import("views/Blog/RelocatingWithSchoolAgeKidsPost")
);
const FirstTimeRelocatorsPost = lazy(() =>
  import("views/Blog/FirstTimeRelocators")
);
const ManageEmployeeRelocationPost = lazy(() =>
  import("views/Blog/ManageEmployeeRelocation")
);
const MakesFriendsAfterRelocationPost = lazy(() =>
  import("views/Blog/MakesFriendsAfterRelocation")
);
//const LoginPage = lazy(() => import("views/LoginPage"));
const AboutUs = lazy(() => import("views/AboutUs"));
const Compare = lazy(() => import("views/Compare"));
const ContactUs = lazy(() => import("views/ContactUs"));
const Disclaimer = lazy(() => import("views/Disclaimer"));
const FAQ = lazy(() => import("views/FAQ"));
const Data = lazy(() => import("views/Data"));
const Template = lazy(() => import("views/Template"));
const CityTemplate = lazy(() => import("views/CityTemplate"));
const Terms = lazy(() => import("views/Terms"));
const Privacy = lazy(() => import("views/Privacy"));
const BigcitySmalltownPost = lazy(() =>
  import("views/Blog/BigcitySmalltownPost")
);
const ProblemWithCrimeData = lazy(() =>
  import("views/Blog/ProblemWithCrimeDataPost")
);

const Rankingpage = lazy(() => import("views/Rankingpage"));

//Amplify.configure(awsExports);

//import SearchLanding from "views/SearchLanding.js";
//import Blog from "views/Blog/Blog.js";
//import BestingBoisePost from "views/Blog/BestingBoisePost";
//import RelocatingWithSchoolAgeKidsPost from "views/Blog/RelocatingWithSchoolAgeKidsPost";
//import FirstTimeRelocatorsPost from "views/Blog/FirstTimeRelocators";
//import ManageEmployeeRelocationPost from "views/Blog/ManageEmployeeRelocation";
//import MakesFriendsAfterRelocationPost from "views/Blog/MakesFriendsAfterRelocation";
// import LoginPage from "views/LoginPage.js";
// import AboutUs from "views/AboutUs.js";
// import Compare from "views/Compare";
// import ContactUs from "views/ContactUs";
// import Disclaimer from "views/Disclaimer";
// import FAQ from "views/FAQ";
// import Data from "views/Data";
// import Template from "views/Template";
// import CityTemplate from "views/CityTemplate";
//import Homepage from "views/Homepage";

const renderFallback = () => <div></div>;

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <Switch>
        {/* <Route path="/" exact render={(props) => <LandingPage {...props} />} /> */}
        <Route
          path="/"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <Homepage {...props} />
            </Suspense>
          )}
        />
        <Route
          path="/search-result"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <SearchLanding {...props} />
            </Suspense>
          )}
        />
        <Route
          path="/blog"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <Blog {...props} />
            </Suspense>
          )}
        />
        <Route
          path="/blog/besting-boise-alternative-places-to-relocate"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <BestingBoisePost {...props} />
            </Suspense>
          )}
        />
        <Route
          path="/blog/relocating-with-school-age-kids"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <RelocatingWithSchoolAgeKidsPost {...props} />
            </Suspense>
          )}
        />
        <Route
          path="/blog/things-all-first-time-relocators-must-know"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <FirstTimeRelocatorsPost {...props} />
            </Suspense>
          )}
        />

        <Route
          path="/blog/how-to-manage-your-employees-relocation"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <ManageEmployeeRelocationPost {...props} />
            </Suspense>
          )}
        />
        <Route
          path="/blog/how-to-make-friends-after-move"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <MakesFriendsAfterRelocationPost {...props} />
            </Suspense>
          )}
        />

        <Route
          path="/compare"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <Compare {...props} />
            </Suspense>
          )}
        />
        {/* <Route
          path="/signin"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <LoginPage {...props} />
            </Suspense>
          )}
        /> */}
        <Route
          path="/aboutus"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <AboutUs {...props} />
            </Suspense>
          )}
        />

        <Route
          path="/contactus"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <ContactUs {...props} />
            </Suspense>
          )}
        />

        <Route
          path="/disclaimer"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <Disclaimer {...props} />
            </Suspense>
          )}
        />

        <Route
          path="/template"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <Template {...props} />
            </Suspense>
          )}
        />
        {/* <Route
          path="/top-cities/:area"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <Template {...props} />
            </Suspense>
          )}
        /> */}

        <Route
          path="/rankings"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <Rankingpage {...props} />
            </Suspense>
          )}
        />

        <Route
          path="/rankings/most-educated-cities-america-2022"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <Template {...props} />
            </Suspense>
          )}
        />

        <Route
          path="/rankings/most-affordable-cities-best-schools-2022"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <Template {...props} />
            </Suspense>
          )}
        />

        <Route
          path="/rankings/best-cities-work-remote-america-2022"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <Template {...props} />
            </Suspense>
          )}
        />

        <Route
          path="/rankings/best-cities-raise-family-south-2022"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <Template {...props} />
            </Suspense>
          )}
        />

        <Route
          path="/rankings/best-cities-raise-family-west-2022"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <Template {...props} />
            </Suspense>
          )}
        />

        <Route
          path="/rankings/best-cities-raise-family-northeast-2022"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <Template {...props} />
            </Suspense>
          )}
        />

        <Route
          path="/rankings/best-cities-raise-family-midwest-2022"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <Template {...props} />
            </Suspense>
          )}
        />

        <Route
          path="/city-template"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <CityTemplate {...props} />
            </Suspense>
          )}
        />

        <Route
          path="/homepage"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <Homepage {...props} />
            </Suspense>
          )}
        />

        <Route
          path="/faq"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <FAQ {...props} />
            </Suspense>
          )}
        />

        <Route
          path="/data"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <Data {...props} />
            </Suspense>
          )}
        />

        <Route
          path="/terms-and-conditions"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <Terms {...props} />
            </Suspense>
          )}
        />

        <Route
          path="/privacy-policy"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <Privacy {...props} />
            </Suspense>
          )}
        />

        <Route
          path="/blog/big-city-small-town"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <BigcitySmalltownPost {...props} />
            </Suspense>
          )}
        />

        <Route
          path="/blog/the-problems-with-crime-data"
          exact
          render={(props) => (
            <Suspense fallback={renderFallback()}>
              <ProblemWithCrimeData {...props} />
            </Suspense>
          )}
        />

        {/* <Route
        path="/reset"
        exact
        render={(props) => <ResetPage {...props} />}
      /> */}
        <Redirect to="/" />
      </Switch>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
